import { ServiceResponse } from '@nx-smartmonkey/shared/hooks';
import { useQuery } from '@tanstack/react-query';

import { weatherService } from '../../../../application/WeatherService';
import { WeatherForecast } from '../../../../domain/weather/WeatherForecast';
import useErrorMiddleware from '../../../../hooks/errorMiddleware/useErrorMiddleware';
import { useRetrieveActiveProject } from '../../../../hooks/project/useRetrieveActiveProject';
import { useShowSnackbarMessage } from '../../../../hooks/snackbarMessage/useShowSnackbarMessage';

type UseRetrieveWeatherForecastResponse = ServiceResponse<Function, WeatherForecast[]>;

export const useRetrieveWeatherForecast = (): UseRetrieveWeatherForecastResponse => {
  const { showSnackbarMessage } = useShowSnackbarMessage();
  const { sessionExpiredLogout } = useErrorMiddleware();
  const { data: project } = useRetrieveActiveProject();

  const {
    data,
    isInitialLoading: isLoading,
    refetch,
    isError,
    isSuccess,
  } = useQuery(
    [`planner_weather_forecast`, project?.id],
    (): Promise<WeatherForecast[]> => {
      return weatherService.retrieveForecast({
        project: project!,
      });
    },
    {
      retry: false,
      enabled: !!project,
      staleTime: 3_600_000, // 1 hour
      onError: (err: any) => {
        console.info(`Weather Forecast Error: `, err?.response);

        if (err?.response?.status === 401) {
          sessionExpiredLogout();
          return;
        }

        showSnackbarMessage({
          messageIntlId: `infoerror.${err?.response?.data?.messageId ?? `network_error`}`,
        });
      },
    }
  );

  return {
    error: isError,
    isLoading,
    success: isSuccess,
    run: refetch,
    data,
  };
};
